
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype2 as ObiMosfetPtype2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-2.js';
 
 
 

 
 export const ObiMosfetPtype2 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-2',
   elementClass: ObiMosfetPtype2Element,
   events: {
     
   }
  });
 
 